import { Box, FormLabel, Stack, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { PricingHelper } from 'pricing/helpers';
import { useCostDecimals } from 'pricing/hooks';
import { Direction, Level } from 'theme/enums';

interface IProps {
  purchaseCost: number | null;
  standardCost: number | null;
}

export const PricingSection = ({ purchaseCost, standardCost }: IProps) => {
  const { t } = useTranslation();
  const costDecimals = useCostDecimals();

  return (
    <Stack direction={Direction.ROW} gap="inherit">
      <Box key={`purchaseCost-${purchaseCost}`} sx={{ width: '100%' }}>
        <FormLabel>{t('labelPurchaseCost')}</FormLabel>
        <Typography level={Level.TITLE_MD}>
          {purchaseCost
            ? PricingHelper.formatPricing({
                amount: purchaseCost,
                decimals: costDecimals,
                fixedDecimals: true,
              })
            : DEFAULT_PLACEHOLDER}
        </Typography>
      </Box>

      <Box key={`standardCost-${standardCost}`} sx={{ width: '100%' }}>
        <FormLabel>{t('labelStandardCost')}</FormLabel>
        <Typography level={Level.TITLE_MD}>
          {standardCost
            ? PricingHelper.formatPricing({
                amount: standardCost,
                decimals: costDecimals,
                fixedDecimals: true,
              })
            : DEFAULT_PLACEHOLDER}
        </Typography>
      </Box>
    </Stack>
  );
};
